<app-menu-bar></app-menu-bar>
<div id="project">
    <div class="title-area">
        <span class="title">{{ project?.title }}</span>

        <!-- Under the title, not in the copy column: the column is capped at the
             image height, and three pills wrapping in a narrow column ate most
             of it, leaving the description a few lines tall. -->
        @if (project?.location || project?.industry || project?.year) {
            <div class="pills">
                @if (project?.location) {
                    <span class="pill">
                        <span class="label">{{ 'field_location' | translate }}</span>
                        <span class="value">{{ project?.location }}</span>
                    </span>
                }
                @if (project?.industry) {
                    <span class="pill">
                        <span class="label">{{ 'field_industry' | translate }}</span>
                        <span class="value">{{ project?.industry }}</span>
                    </span>
                }
                @if (project?.year) {
                    <span class="pill">
                        <span class="label">{{ 'field_year' | translate }}</span>
                        <span class="value">{{ project?.year }}</span>
                    </span>
                }
            </div>
        }
    </div>

    <div class="overview">
<!-- The frame holds the reserved box and the placeholder; the image fades
             into it once it has actually decoded, so the column never shows a
             transparent hole or a half-painted picture. Coming from a carousel
             card the photo is already cached and this resolves on the first
             frame; it earns its keep on a direct link to this page. -->
        <div class="project-image-frame">
            <img [src]="project?.imageUrl" alt="" class="project-image"
                 [class.is-loaded]="imageLoaded"
                 (load)="imageLoaded = true"
                 (error)="imageLoaded = true"
                 fetchpriority="high" decoding="async">
        </div>
        <!-- Markdown, so the copy can carry paragraphs and the odd bold
             run; the pipe escapes the source before building any of it.
             `description` is not this — that is the carousel hover text. -->
        <div class="copy">
            <div #copyScroll class="description" [class.no-fade]="!showCopyFade"
                (scroll)="onCopyScroll()"
                [innerHTML]="project?.detailedDescription | richText"></div>
            <!-- Absolute against .copy, which is the same bottom edge the
                 description ends on, so the chevron does not scroll with it. -->
            @if (showScrollHint) {
                <span class="scroll-hint" aria-hidden="true">
                    <i class="fa-light fa-angle-down"></i>
                </span>
            }
        </div>
    </div>

    <div class="carousel-area">
        <span class="title">{{ 'project_carousel_title' | translate }}</span>
        @if (carouselItems.length) {
            <app-image-carousel [carouselItems]="carouselItems"></app-image-carousel>
        }
    </div>
</div>
<app-footer></app-footer>
